import { ReactNode } from 'react';
import { Tooltip, Typography } from 'antd';
import { StyledCopyIcon } from './styles';

type Props = {
    copyText: string;
    dataTestId?: string;
    children?: ReactNode;
};

const TooltipWithCopy = ({ copyText, dataTestId, children }: Props) => {
    return (
        <Tooltip
            color="white"
            title={
                <Typography.Text
                    style={{ overflowWrap: 'anywhere' }}
                    // The tooltip is portalled, but React still bubbles its clicks to the trigger's
                    // ancestors - copying inside a clickable table row must not also open the row.
                    onClick={(event) => event.stopPropagation()}
                    data-testid={dataTestId ? `${dataTestId}-overlay` : undefined}
                    copyable={{
                        text: copyText,
                        icon: [<StyledCopyIcon key="copy-icon" />],
                    }}
                >
                    {children}
                </Typography.Text>
            }
        >
            <span data-testid={dataTestId}>{children}</span>
        </Tooltip>
    );
};

export default TooltipWithCopy;
